import React, { memo } from 'react';

import TextAvatar from '@components/common/TextAvatar';

import styles from './IconCell.module.scss';

interface IIconCell {
	id: string;
	text?: string;
	size?: string;
	fontSize?: string;
	onClick?: () => void;
	isLogoSquare?: boolean;
}

const IconCell = ({
	id,
	text,
	size = '28px',
	fontSize = '10px',
	onClick,
	isLogoSquare,
}: IIconCell) => {
	return (
		<div
			className={styles.wrapper}
			onClick={onClick}
		>
			<TextAvatar
				avatarId={id}
				firstName={text}
				fontSize={fontSize}
				isLogoSquare={isLogoSquare}
				isProfileLogo
				size={size}
			/>
			{text && <span className={styles.text}>{text}</span>}
		</div>
	);
};

export default memo(IconCell);
